import MessageList from './MessageList';
import { IMessageList } from './MessageList.interfaces';

export default MessageList;
export { MessageList, IMessageList };
